import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import CollapsableSimpleCard from "./CollapsableSimpleCard";
import "./EventsList.scss";
import { useAppSelector } from "store/hooks";
import { useState } from "react";

export default function EventsList(props: { goals? }) {
  const notifications = useAppSelector((state) => state.notifications.notifications);
  const [checkedEvents, setCheckedEvents] = useState(0);

  // Function to format date to "MMM DD - hh:mm A" format
  const formatDate = (dateString: string) => {
    const options: Intl.DateTimeFormatOptions = {
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    };
    return new Date(dateString).toLocaleString("en-US", options);
  };

  return (
    <div className="events-list">
      {Array(1)
        .fill(1)
        .map((_, card_i) => (
          <CollapsableSimpleCard onChange={(e, expanded) => {
            if (expanded) {
              setCheckedEvents(notifications.length);
            }
          }} key={`${card_i}0`} card_title={`${notifications.length - checkedEvents} updates to check${notifications.length - checkedEvents > 0 ? "!" : "."}`}>
            <div key={`${card_i}1`} className="events-card-content">
              {notifications.slice(0).reverse().map((event, events_i) => (
                  <Paper
                    key={`${card_i}${events_i + 1}2`}
                    className="event"
                    variant="outlined"
                  >
                    <Typography
                      key={`${card_i}${events_i + 1}3`}
                      className="event-date"
                    >
                      {formatDate(event?.value?.created_at)}
                    </Typography>
                    <code
                      key={`${card_i}${events_i + 1}4`}
                      className="event-text relative overflow-hidden shadow-xl flex bg-slate-800 !h-auto max-h-[none] text-slate-50 p-4"
                    >
                      {JSON.stringify(event?.value?.data, null, 2)}
                    </code>
                    <img
                      key={`${card_i}${events_i + 1}5`}
                      src={require("assets/info_circle.svg").default}
                      alt=""
                      className="event-icon"
                    />
                  </Paper>
                ))}
            </div>
          </CollapsableSimpleCard>
        ))}
    </div>
  );
}
